import {pinyin} from 'pinyin-pro';

export default function (Vue, options) {
    Vue.prototype.vmChangetime = function (val) {
        let theTime = parseInt(val); // 秒
        let theTime1 = 0; // 分
        let theTime2 = 0; // 小时
        let theTime3 = 0; // 天
        if (theTime > 60) {
            theTime1 = parseInt(theTime / 60);
            if (theTime1 > 60) {
                theTime2 = parseInt(theTime1 / 60);
                if (theTime2 > 24) {
                    theTime3 = parseInt(theTime2 / 24);
                    theTime2 = parseInt(theTime2 % 24);
                }
            }
        }
        return theTime3 + '天' + theTime2 + '时';
    };

    // 获取当前时间(时分)
    Vue.prototype.vmTimeNow = function () {
        let d = new Date();
        return d.getHours() + ':' + d.getMinutes();
    };

    // 对Date的扩展，将 Date 转化为指定格式的String
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
    // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
    // 例子：
    // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
    // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
    Date.prototype.Format = function (fmt) {
        var weeks = ['日', '一', '二', '三', '四', '五', '六'];
        var o = {
            'M+': this.getMonth() + 1, //月份
            'd+': this.getDate(), //日
            'h+': this.getHours(), //小时
            'm+': this.getMinutes(), //分
            's+': this.getSeconds(), //秒
            'q+': Math.floor((this.getMonth() + 3) / 3), //季度
            S: this.getMilliseconds(), //毫秒
            W: weeks[this.getDay()], //星期
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        return fmt;
    };

    /**
     * 获取地理位置和城市信息
     */
    Vue.prototype.Geolocation = function () {
        const self = this;
        const ins = setInterval(() => {
            if (window.BMap && BMap.Geolocation) {
                clearInterval(ins);
                if (self.$store.state.app.Citylist.length == 0) {
                    const geolocation = new BMap.Geolocation();
                    geolocation.getCurrentPosition(
                        function (r) {
                            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                                self.$store.dispatch('app/getCitiesByType', {type: 2, cityname: r.address.city});
                            } else {
                                alert('failed' + this.getStatus());
                            }
                        },
                        {enableHighAccuracy: true}
                    );
                }
            }
        }, 500);
    };

    /**
     * 数组比较大小
     * @param {*} prop
     * @param {*} reserve
     */
    function arrayCompare(prop, reserve = 'id') {
        return (a, b) => {
            let v1 = a[prop];
            let v2 = b[prop];
            return v1 != v2 ? v1 - v2 : a[reserve] - b[reserve];
        };
    }

    /**
     * 数组排序
     * @param {*} arr
     */
    Vue.prototype.arraySort = arr => {
        arr.sort(arrayCompare('sort'));
        arr.forEach(v => {
            if (v.children && v.children.length > 1) {
                Vue.prototype.arraySort(v.children);
            }
        });
    };

    /**
     *
     * 判断是否有按钮权限
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.checkBtnPermission = function (data) {
        if (!data) return true;
        const BtnPermissions = window.IMS_API.btnPermissions;
        if (typeof data === 'string') {
            return BtnPermissions.indexOf(data) !== -1;
        } else if (Array.isArray(data)) {
            let d = data.filter(v => BtnPermissions.indexOf(v.btnKey) !== -1);
            return d;
        }
    };

    /**
     *
     * 获取产品列表
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getProducts = function () {
        let res = JSON.parse(localStorage.getItem('ListProductMap'));
        return res;
    };
    /**
     *
     * 获取产品的规格列表
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getProductsS = function (key) {
        let res = JSON.parse(localStorage.getItem('ListSOfProductMap'));
        return res[key];
    };

    /**
     *
     * 获取产品的材质列表
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getProductsM = function (key) {
        let res = JSON.parse(localStorage.getItem('ListMOfProductMap'));
        return res[key];
    };
    /**
     *
     * 获取产品的生产产地
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getProductsFactory = function (key) {
        let res = JSON.parse(localStorage.getItem('ListFactoryMap'));
        return res;
    };
    /**
     *
     * 判断状态
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getOptions = function (key) {
        let res = JSON.parse(localStorage.getItem('ListAllSubByMap'));
        return res[key];
    };

    /**
     *
     * 判断状态
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getOptionsValue = function (value) {
        let _res = JSON.parse(localStorage.getItem('ListAllSubByMap'));
        let res = Object.values(_res);
        let name = '';
        try {
            res.forEach(item => {
                let _item = item.filter(o => o.id === value);
                if (_item.length > 0) {
                    name = _item[0].name;
                    throw new Error();
                }
            });
        } catch (e) {}
        return name;
    };
    Vue.prototype.approveStatus = [
        {
            name: '待提交',
            value: 0,
        },
        {
            name: '已提交',
            value: 1,
        },
        {
            name: '已审核',
            value: 2,
        },
        {
            name: '已驳回',
            value: 5,
        },
    ];
    Vue.prototype.bStatus = [
        {
            name: '执行中',
            value: 1,
        },
        {
            name: '已完成',
            value: 5,
        },
    ];

    Vue.prototype.Status = [
        {
            name: '未完成',
            value: 0,
        },
        {
            name: '已完成',
            value: 1,
        },
    ];
    Vue.prototype.getApproveStatus = function (approve, type) {
        if (type == 2 || type == 5) {
            if (type == 5) return "<span   style='color:red;font-size:12px'>被驳回</span>";
            else return "<span   style='color:green;font-size:12px'>已批准</span>";
        } else {
            let status = approve;
            //审批状态 0待提交1已提交2已审核5驳回
            if (status == 0) {
                return "<span   style='color:gray;font-size:12px'>待提交</span>";
            } else if (status == 1) {
                return "<span   style='color:blue;font-size:12px'>审批中</span>";
            } else if (status == 2) {
                return "<span    style='color:green;font-size:12px'>已批准</span>";
            } else if (status == -1) {
                return "<span   style='color:blue;font-size:12px'>待审批</span>";
            } else {
                return "<span   style='color:red;font-size:12px'>已驳回</span>";
            }
        }
    };
    /**
     *
     * 判断状态
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getStatus = function (status, approve = 2) {
        if (approve != 2) {
            return "<span class='green' style='color:green;font-size:12px'></span>";
        }
        if (status == 1) {
            return "<span class='green' style='color:green;font-size:12px'>启用</span>";
        } else if (status == 0) {
            return "<span  class='grey' style='color:red;font-size:12px'>禁用</span>";
        } else {
            return "<span  class='grey' style='color:red;font-size:12px'>关闭</span>";
        }
    };
    Vue.prototype.getCStatus = function (status, p1, p2) {
        if (status == 1 || !status) {
            return `<span  style='color:green;font-size:12px'>${p1}</span>`;
        } else {
            return `<span   style='color:blue;font-size:12px'>${p2}</span>`;
        }
    };

    /**
     * 已审批业务单价状态0正常 5已关闭
     * @param {*} status
     * @param {*} approve
     * @returns
     */
    Vue.prototype.getBStatus = function (status, approve = 2, title = '已完成') {
        if (approve != 2) {
            return "<span class='green' style='color:green;font-size:12px'></span>";
        }
        if (status == 1) {
            return "<span  class='green' style='color:green;font-size:12px'>执行中</span>";
        } else if (status == 5) {
            return `<span  class='blue' style='color:blue;font-size:12px'>${title}</span>`;
        } else {
            return "<span  class='green' style='color:green;font-size:12px'></span>";
        }
    };
    Vue.prototype.parseCoopType = function (coopType) {
        let [v, i, arr] = [0, 0, []];
        while (v <= coopType) {
            v = 1 << i;
            if (coopType & v) arr.push(v);
            i = i + 1;
        }
        return arr;
    };

    /**
     * 往来单位已审核通过后，维护银行账户/联系人前的二次确认。
     * 银行账户、联系人是独立子表，确认后直接落库，不重新发起审批、不影响审批状态；
     * 未审核（待提交/审批中/已驳回）时不弹提示，按原有流程处理。
     *
     * @param {Number} corptype 业务类型（2的幂，如 2/4/8/16/32/64/128）
     * @param {Number} approve  coop_company.approve 位值（各业务类型的审批状态拼成一个8位数字）
     * @returns {Promise<Boolean>} true 继续保存，false 取消
     */
    Vue.prototype.confirmCoopChildChange = function (corptype, approve) {
        const pos = corptype && corptype > 0 ? Math.round(Math.log2(corptype)) : 0;
        let approveStr = String(approve == null ? 0 : approve);
        while (approveStr.length < 8) approveStr = '0' + approveStr;
        // 审批状态 0待提交 1已提交 2已审核 5驳回
        if (approveStr.charAt(pos) !== '2') return Promise.resolve(true);
        return this.$confirm('该往来单位已审核通过，银行账户/联系人将直接保存生效，不会重新发起审批，是否继续？', '提示', {type: 'warning'})
            .then(() => true)
            .catch(() => false);
    };

    Vue.prototype.makeBBtnModify = function (approve, status) {
        const modifyArr = [];
        if (approve == 0 || approve == 5) {
            modifyArr.push({name: '提交', type: 'success', method: this.handleSubmit});
            modifyArr.push({name: '删除', type: 'danger', method: this.handleDelete});
            modifyArr.push({name: '编辑', type: 'primary', method: this.handleEdit});
        } else if (approve == 1) {
            modifyArr.push({name: '撤回', type: 'warning', method: this.handleBack});
        } else {
            if (status == 5) modifyArr.push({name: '打开', type: 'success', method: this.handleClose});
            else modifyArr.push({name: '关闭', type: 'danger', method: this.handleClose});
        }
        modifyArr.push({name: '详细', type: 'info', method: this.goDetail});
        return modifyArr;
    };

    Vue.prototype.getFirstLetter = function (caption) {
        let pinyinArr = pinyin(caption.substring(0, 6), {pattern: 'first', separator: ''});
        return pinyinArr.toUpperCase();
    };

    Vue.prototype.getSummaries = function (param, cols) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            }
            let fix = column.fix ? column.fix : 2;
            if (cols.includes(index)) {
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        // const value = Number(curr);
                        // if (!isNaN(value)) {
                        let v = parseFloat(Number(curr)) + parseFloat(Number(prev));
                        return parseFloat(v).toFixed(fix);
                        // } else {
                        // return parseFloat(prev).toFixed(fix);
                        // }
                    }, 0);
                    // sums[index] += '';
                } else {
                    // sums[index] = 'N/A';
                }
            }
        });
        return sums;
    };
}



// WEBPACK FOOTER //
// ./src/utils/glbfunction.js